<div class="park-calendar" [style.--range-color]="buttonColorActive">
  <div class="calendar-header" [style.background]="buttonColorActive">
    <button type="button" (click)="prevMonth()" aria-label="Mes anterior"><i class="bi bi-caret-left-fill"></i></button>
    <span class="month-name">{{ monthLabel }}</span>
    <button type="button" (click)="nextMonth()" aria-label="Mes siguiente"><i class="bi bi-caret-right-fill"></i></button>
  </div>

  <div class="calendar-container">
    <ol class="container-calendar" (mouseleave)="preview(null)">
      <li *ngFor="let w of weekdays" class="week-day"><p class="week-day-text">{{ w }}</p></li>

      <li *ngFor="let day of calendarDays; trackBy: trackByDate"
          class="calendar-day"
          [class.date-available]="day.isAvailable"
          [class.other-month]="!day.isCurrentMonth"
          [class.in-range]="day.inRange"
          [class.range-start]="day.isStart"
          (mouseenter)="preview(day)"
          (click)="pick(day)">
        <span class="day-number">{{ day.isCurrentMonth ? day.number : '' }}</span>

        <div class="day-prices" *ngIf="day.isAvailable">
          <span class="price-label">Desde</span>
          <span class="price-original">{{ sourceCurrency }} {{ day.price | number: '1.2-2' }}.-</span>
          <span class="price-amount" *ngIf="sourceCurrency !== currencyAgency?.code">
            {{ currencyAgency?.code }}
            {{ day.price | currencyConverterPure: sourceCurrency: currencyAgency?.code: currencies | number: '1.2-2' }}.-
          </span>
        </div>
      </li>
    </ol>
  </div>
</div>
